import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/shared/api/problem';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        // błędy 4xx (uprawnienia, walidacja, brak zasobu) nie znikną przy ponowieniu
        retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
      },
      mutations: { retry: false },
    },
  });
}
